import create from './create'
import update from './update'
import remove from './remove'
import list from './list'
import details from './details'

export default { create, update, remove, list, details }
